import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface SiteContextModel {
    bottomSpacing?: number;
    setBottomSpacing: Dispatch<SetStateAction<SiteContextModel["bottomSpacing"]>>;
}

export const SiteContext = createContext<SiteContextModel>({} as any);
export const useSiteContext = () => useContext(SiteContext);
